import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, getDocs, query, where, addDoc, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);

  // Charger les réservations
  const loadBookings = async (userId = null) => {
    setLoading(true);
    try {
      let bookingsQuery;
      if (userId) {
        bookingsQuery = query(collection(db, 'bookings'), where('userId', '==', userId));
      } else {
        bookingsQuery = collection(db, 'bookings');
      }
      
      const bookingsSnapshot = await getDocs(bookingsQuery);
      const bookingsData = bookingsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setBookings(bookingsData);
      return bookingsData;
    } catch (error) {
      console.error('Erreur lors du chargement des réservations:', error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  // Créer une réservation
  const createBooking = async (bookingData) => {
    try {
      const docRef = await addDoc(collection(db, 'bookings'), {
        ...bookingData,
        createdAt: new Date(),
        status: 'pending'
      });
      return docRef.id;
    } catch (error) {
      console.error('Erreur lors de la création de la réservation:', error);
      throw error;
    }
  };

  // Mettre à jour une réservation
  const updateBooking = async (bookingId, updateData) => {
    try {
      await updateDoc(doc(db, 'bookings', bookingId), {
        ...updateData,
        updatedAt: new Date()
      });
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la réservation:', error);
      throw error;
    }
  };

  const value = {
    bookings,
    loading,
    loadBookings,
    createBooking,
    updateBooking
  };

  return (
    <BookingContext.Provider value={value}>
      {children}
    </BookingContext.Provider>
  );
};

